import { FormattedMessage } from 'react-intl'
import { Link as RouterLink } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Link from '@mui/material/Link'
import Chip from '@mui/material/Chip'
import Button from '@mui/material/Button'
import FlexColumn from '../../../shared/components/layouts/FlexColumn'

const getNodeStatus = (node) => {
  if (!node.lastSeenAt) return 'unknown'
  const lastSeen = new Date(node.lastSeenAt)
  const fiveMinutesAgo = new Date(Date.now() - 5 * 60 * 1000)
  return lastSeen > fiveMinutesAgo ? 'online' : 'offline'
}

const getStatusColor = (status) => {
  switch (status) {
    case 'online':
      return 'success'
    case 'offline':
      return 'error'
    default:
      return 'default'
  }
}

function UnconfirmedNodes({ nodes, teamSlug, onConfirm }) {
  if (nodes.length === 0) {
    return (
      <FlexColumn gap={2}>
        <Typography variant="h3">
          <FormattedMessage id="nodes.create.unconfirmedNodes.title" />
        </Typography>
        <Typography color="text.secondary">
          <FormattedMessage id="nodes.create.unconfirmedNodes.empty" />
        </Typography>
      </FlexColumn>
    )
  }

  return (
    <FlexColumn gap={2}>
      <Typography variant="h3">
        <FormattedMessage id="nodes.create.unconfirmedNodes.title" />
      </Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <FormattedMessage id="nodes.index.columns.status" />
              </TableCell>
              <TableCell>
                <FormattedMessage id="nodes.index.columns.name" />
              </TableCell>
              <TableCell>
                <FormattedMessage id="nodes.index.columns.ip" />
              </TableCell>
              <TableCell>
                <FormattedMessage id="nodes.index.columns.actions" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {nodes.map((node) => {
              const status = getNodeStatus(node)
              return (
                <TableRow key={node.id}>
                  <TableCell>
                    <Chip
                      label={<FormattedMessage id={`nodes.status.${status}`} />}
                      color={getStatusColor(status)}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Link
                      component={RouterLink}
                      to={`/teams/${teamSlug}/nodes/${node.id}`}
                    >
                      {node.name}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                      {node.ip || '-'}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => onConfirm(node)}
                    >
                      <FormattedMessage id="nodes.create.unconfirmedNodes.confirmButton" />
                    </Button>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </FlexColumn>
  )
}

export default UnconfirmedNodes
